import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";

export const PositioningSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="positioning" className="py-32 md:py-40 px-6 md:px-12 bg-[#0A0A0A]" data-testid="positioning-section">
      <div className="max-w-5xl mx-auto" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.9, ease: "easeOut" }}
        >
          <div className="gold-line w-20 mb-12"></div>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#F5F5F0] leading-[1.2] tracking-tight mb-8" data-testid="positioning-title">
            Où précision, durabilité<br className="hidden md:block" /> et esthétique <span className="italic text-[#E8891C]">se rencontrent.</span>
          </h2>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
        >
          <p className="font-sans text-base md:text-lg text-[#A1A1AA] leading-relaxed max-w-3xl" data-testid="positioning-text">
            Paysagement multi-concepts crée des aménagements extérieurs où précision, durabilité et esthétique se rencontrent. Chaque projet est conçu pour offrir une finition irréprochable et une présence visuelle forte.
          </p>
        </motion.div>
      </div>
    </section>
  );
};
